import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateExamQuestionList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ExamQuestion/CreateList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteExamQuestionList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ExamQuestion/DeleteList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export { CreateExamQuestionList, DeleteExamQuestionList };
